<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <app-table
          :config="config"
          @references="references"
        />

        <v-dialog
          v-model="openReference"
          max-width="750px">

          <app-table
            v-if="openReference"
            :config="referenceConfig"
            :hidden-fields="{ disposal_id: disposal.id }"
            :filters="{ disposal_id: disposal.id }"
            :subtitle="disposal.name"
            modal
            no-search
            hide-upsert
            inline-upsert
            title="Disposal center references"
            @close="openReference=false" />

        </v-dialog>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_index.js'
import referenceConfig from './config_reference.js'

export default {
  data () {
    return {
      config,
      referenceConfig,
      openReference: false,
      disposal: {}
    }
  },
  methods: {
    references (disposal) {
      this.disposal = disposal
      this.openReference = true
    }
  }
}
</script>
